/** Shared AI-role gate for Disha AI /chat + DishaChat assistant pin */

export const DISHA_AI_ROLE_ID = '69f197411b2324e71b7805d0';

function isAiRoleName(name) {
  const value = String(name || '')
    .trim()
    .toLowerCase()
    .replace(/\s+/g, ' ');
  if (!value) return false;
  return value === 'ai' || value === 'disha ai' || value === 'dishaai';
}

/**
 * True when user has the AI role.
 * Auth roles are objects like `{ _id, name: 'AI' }` (same shape used elsewhere in auth).
 */
export function hasDishaAiAccess(user) {
  const roles = user?.roles || [];
  if (!Array.isArray(roles) || !roles.length) return false;

  return roles.some(role => {
    if (role == null) return false;

    if (typeof role === 'string') {
      const value = role.trim();
      return value === DISHA_AI_ROLE_ID || isAiRoleName(value);
    }

    const id = String(role._id || role.id || '').trim();
    if (id && id === DISHA_AI_ROLE_ID) return true;

    return isAiRoleName(role.name || role.roleName || role.label);
  });
}
